var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import cartUtil, { getOrphanedItems } from '../helpers/cartUtil';
const initMiniCart = () => {
    const selectors = {
        quickCart: '.quick-cart',
        cartProducts: '.quick-cart__main-content',
        cartItem: '.quick-cart__item',
        qtyBtns: '.cart-item-bundle [data-subtract-quantity], .cart-item-bundle [data-add-quantity]',
        increaseButtons: '.cart-item-bundle [data-add-quantity]',
        removeItemButton: '[data-remove-item]',
        removeBundleButton: '[data-cg-quick-cart-delete]',
    };
    const classes = {
        buttonDisbled: 'quick-cart__item-remove--disabled',
        isPending: 'pending-quantity-update',
        isRemoved: 'is-removed',
    };
    const cartProducts = document.querySelector(selectors.cartProducts);
    if (cartProducts) {
        const observer = new MutationObserver((mutationList) => {
            for (const mutation of mutationList) {
                if (mutation.type === 'childList') {
                    attachEventListenerToBundleRemove();
                    attachEventListenerToQuanityChange();
                }
            }
        });
        observer.observe(cartProducts, { childList: true, subtree: true });
    }
    const attachEventListenerToBundleRemove = () => __awaiter(void 0, void 0, void 0, function* () {
        const removeItemButtons = document.querySelectorAll(selectors.removeItemButton);
        const removeBundleButtons = document.querySelectorAll(selectors.removeBundleButton);
        if (removeBundleButtons.length > 0) {
            Array.from(removeBundleButtons).forEach((cartBundleDelete) => {
                cartBundleDelete.addEventListener('click', (event) => __awaiter(void 0, void 0, void 0, function* () {
                    event.preventDefault();
                    if (removeItemButtons.length > 0) {
                        removeItemButtons.forEach((button) => {
                            button.classList.add(classes.buttonDisbled);
                        });
                    }
                    const bundleParts = cartBundleDelete.dataset.cgBundleProducts.split(',');
                    if (bundleParts) {
                        const lineItem = cartBundleDelete.closest(selectors.cartItem);
                        lineItem.classList.add(classes.isPending);
                        lineItem.classList.add(classes.isRemoved);
                        yield cartUtil.removeBundle(bundleParts, 'quick-cart');
                        setTimeout(() => {
                            initMiniCart();
                        }, 500);
                    }
                }));
            });
        }
        if (removeItemButtons.length > 0) {
            removeItemButtons.forEach((button) => {
                button.addEventListener('click', () => {
                    removeItemButtons.forEach((button) => {
                        button.classList.add(classes.buttonDisbled);
                    });
                    if (removeBundleButtons.length > 0) {
                        removeBundleButtons.forEach((button) => {
                            button.classList.add(classes.buttonDisbled);
                        });
                    }
                });
            });
        }
    });
    const attachEventListenerToQuanityChange = () => __awaiter(void 0, void 0, void 0, function* () {
        const qtyBtns = document.querySelectorAll(selectors.qtyBtns);
        if (qtyBtns.length > 0) {
            Array.from(qtyBtns).forEach((qtyBtn) => {
                qtyBtn.addEventListener('click', (event) => __awaiter(void 0, void 0, void 0, function* () {
                    event.preventDefault();
                    const inputValue = qtyBtn.parentElement.querySelector('input').value;
                    const bundleParts = qtyBtn.dataset.cgBundleProducts.split(',');
                    if (bundleParts) {
                        const lineItem = qtyBtn.closest(selectors.cartItem);
                        lineItem.classList.add(classes.isPending);
                        // TODO
                        // map through bundle parts and update quantity to inputValue + 1
                        // This is currently blocked as the theme js still runs
                        // await cartUtil.change(bundleParts);
                        // setTimeout(() => {
                        //   initMiniCart();
                        // }, 500);
                    }
                }));
            });
        }
    });
    attachEventListenerToBundleRemove();
    attachEventListenerToQuanityChange();
    const checkForOrphansInCart = () => __awaiter(void 0, void 0, void 0, function* () {
        console.log('MINI CART: check for orphans in cart');
        const cart = yield cartUtil.get();
        if (cart.data.items.length > 0) {
            const orphanedItems = getOrphanedItems(cart.data.items);
            console.log('MINI CART: orphanedItems', orphanedItems);
            if (orphanedItems.length > 0) {
                cartUtil.removeBundle(orphanedItems.map((item) => item.key), 'quick-cart');
            }
        }
    });
    const quickCart = document.querySelector(selectors.quickCart);
    if (quickCart) {
        checkForOrphansInCart();
    }
};
export default initMiniCart;
